import _ from 'lodash';

export const hasAccountOptionEnabled = (option) => (account) =>
  Boolean(_.get(account.options, option, false));
